import { Injectable } from '@angular/core';
import { Role } from '../../common';
import { UserRolesModel } from '../../store';

@Injectable({
  providedIn: 'root',
})
export class RolesSelectionService {
  rolesModelToRoleList(rolesModel: UserRolesModel | Role[]): Role[] {
    if (!rolesModel) {
      return [];
    }

    const roleArrays = Object?.values(rolesModel);
    const flattenedRoles = roleArrays.flatMap((roleArray: Role[]) => roleArray);
    return flattenedRoles;
  }

  rolesModelWithoutEmptyUserRoleType(rolesModel: UserRolesModel): UserRolesModel {
    for (const key in rolesModel) {
      if (rolesModel[key].length === 0) {
        delete rolesModel[key];
      }
    }
    return rolesModel;
  }
}
